var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6417 9.22681H3.30835V15.8935C3.30835 18.3935 4.14168 19.2268 6.64168 19.2268H13.3084C15.8084 19.2268 16.6417 18.3935 16.6417 15.8935V9.22681Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9166 6.72697V7.5603C17.9166 8.47697 17.4749 9.22697 16.2499 9.22697H3.74992C2.47492 9.22697 2.08325 8.47697 2.08325 7.5603V6.72697C2.08325 5.8103 2.47492 5.0603 3.74992 5.0603H16.2499C17.4749 5.0603 17.9166 5.8103 17.9166 6.72697Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.69998 5.06017H5.09998C4.81665 4.75184 4.82498 4.27684 5.12498 3.97684L6.30832 2.79351C6.61665 2.48517 7.12498 2.48517 7.43332 2.79351L9.69998 5.06017Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8917 5.06017H10.2917L12.5584 2.79351C12.8667 2.48517 13.3751 2.48517 13.6834 2.79351L14.8667 3.97684C15.1667 4.27684 15.1751 4.75184 14.8917 5.06017Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44995 9.22681V13.5101C7.44995 14.1768 8.18328 14.5685 8.74162 14.2101L9.52495 13.6935C9.80829 13.5101 10.1666 13.5101 10.4416 13.6935L11.1833 14.1935C11.7333 14.5601 12.475 14.1685 12.475 13.5018V9.22681H7.44995Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.d1f5c9e4125fe9809b83c2b8adeca8bb.svg";
export { ForwardRef as ReactComponent };